import { render, staticRenderFns } from "./verify-reg.vue?vue&type=template&id=4e8c366a&lang=html&"
import script from "./verify-reg.vue?vue&type=script&lang=js&"
export * from "./verify-reg.vue?vue&type=script&lang=js&"
import style0 from "./verify-reg.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../rewards-admin-portal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports